export const GET_ALL_VPIN_PROJECTS = 'GET_ALL_VPIN_PROJECTS';
export const GET_ALL_VPIN_PROJECTS_SUCCESS = 'GET_ALL_VPIN_PROJECTS_SUCCESS';
export const GET_ALL_VPIN_PROJECTS_ERROR = 'GET_ALL_VPIN_PROJECTS_ERROR';

export const GET_ALL_LRS_PROJECTS = 'GET_ALL_LRS_PROJECTS';
export const GET_ALL_LRS_PROJECTS_SUCCESS = 'GET_ALL_LRS_PROJECTS_SUCCESS';
export const GET_ALL_LRS_PROJECTS_ERROR = 'GET_ALL_LRS_PROJECTS_ERROR';

export const GET_LRS_PROJECT_PROCEDURES = 'GET_LRS_PROJECT_PROCEDURES';
export const GET_LRS_PROJECT_PROCEDURES_SUCCESS = 'GET_LRS_PROJECT_PROCEDURES_SUCCESS';
export const GET_LRS_PROJECT_PROCEDURES_ERROR = 'GET_LRS_PROJECT_PROCEDURES_ERROR';